/* analytics */
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'

import mediumZoom from 'medium-zoom'
global.mediumZoom = mediumZoom

global._ = require('lodash')

global.mediumZoomOptions = {
	background: '#2e2e2e',
	scrollOffset: 0,
}

import iziToast from 'izitoast'
global.iziToast = iziToast

iziToast.settings({position: 'topRight'})

import axios from 'axios'
global.axios = axios

import navigation from './navigation'

import mapComponent from './map'
global.mapComponent = mapComponent

import ScrollOnePageController from './ScrollOnePageController'
import NavComponent from './NavComponent'
import contactForm from './ContactForm.vue'
import BreadComponent from './BreadComponent'

import sliderPrimary from './sliderPrimary'


global.EventBus = new Vue({});

window.addEventListener('load', function(){
		window.cookieconsent.initialise({
			"palette": {
				"popup": {
					"background": "#252424",
					"text": "#ccc"
				},
				"button": {
					"background": "#8cd5f9",
					"color" : "#fffff"
				}
			},
			"theme": "edgeless",
			"content": {
				"message": "En poursuivant votre navigation sur ce site, vous acceptez l'installation et l'utilisation de cookies sur votre navigateur.",
				"dismiss": "Continuer",
				"link": "En savoir plus",
				"href" : "https://www.gouvernement.fr/donnees-personnelles-et-cookies"
			}
		});

		mediumZoom('.page img')

		document.querySelector('#navComponent') !== null ? NavComponent.init() : null
		document.querySelector('#footerMap') !== null ? mapComponent.boot() : null
		document.querySelector('#frontPage') !== null ? ScrollOnePageController.init() : null
		document.querySelector('#navigationPrimary') !== null ? navigation.init() : null 

		var contactEl = document.querySelector('contact-form')
		if (contactEl !== null) {
			new Vue({
				el: contactEl,
				render: h => h(contactForm)
			})
		}


		document.querySelector('#sliderPrimary') !== null ? sliderPrimary.init() : null;

		document.querySelector('.our-breads-page') !== null ? BreadComponent.init() : null; 



		var loader = document.querySelector('#loaderFull')
			if (loader !== null) {
				TweenMax.fromTo(loader, 1, {opacity: 1}, {opacity: 0, display: 'none', ease: Power2.easeOut})
			}

		var imgs = document.querySelectorAll('[data-src]');

		for (var i = 0; i < imgs.length; i++) {
			imgs[i].setAttribute('src', imgs[i].getAttribute('data-src'));
		}

})